import React from "react"
import { Script } from "gatsby"
import Layout from "./src/components/Layout"

export const wrapPageElement = ({ element, props }, themeOptions) => {
  return (
    <>
      <Layout {...props}>
        {element}
      </Layout>
      <Script
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      />
      <Script
        src="/livechat.js"
      />
      <Script
        src="/.netlify/functions/calltracks"
      />
    </>
  );
}
